import React from 'react';
import PropTypes from 'prop-types';

const TourClients = ({ translate }) => ({
  run: false,
  stepIndex: 0,
  steps: [
    {
      content: (
        <>
          <p>
            {translate('custom.tour.tourClients.screen1.text1')}
          </p>
          <p>
            {translate('custom.tour.tourClients.screen1.text2')}
          </p>
        </>
      ),
      placement: 'center',
      styles: {
        options: {
          width: 900,
        },
      },
      target: 'body',
      title: translate('custom.tour.tourClients.screen1.title'),
    },
    {
      title: 'Puedes reiniciar el tour',
      content: (
        <div>
          <h3>Con este botón empieza de nuevo el tour</h3>
        </div>
      ),
      target: '.demo__segundo',
      placement: 'bottom',
    },
    {
      title: 'Este es el listado de clientes disponible',
      content: 'En este apartado podrás llevar a cabo acciones relacionadas con tus clientes',
      target: '.RaList-main-43',
      placement: 'bottom',
    },
    {
      title: 'Cabecera de la tabla',
      content: 'Haz click en alguno de los campos para ordenar de manera ascendente o descendente',
      target: '.RaDatagrid-headerRow-75',
      placement: 'bottom',
    },
    {
      title: 'Campo de búsqueda',
      content: 'Aquí podrás buscar por el nombre del cliente',
      target: '#q',
      placement: 'bottom',
    },
    {
      title: 'Filtros',
      content: 'Aqui podrás ir añadiendo filtros a tu búsqueda',
      target: '[data-testid="clients-filters"]',
      placement: 'bottom',
    },
  ],
});

TourClients.propTypes = {
  translate: PropTypes.func.isRequired,
};

export default TourClients;
